import { FC, useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { Box } from '@mui/material';
import { FormContainer } from '@client/foundation/layout/form-container';
import { FormField } from '@client/foundation/form/form-field';
import { FieldWrapper } from '@client/foundation/layout/field-wrapper';
import { SubmitButton } from '@client/foundation/form/buttons/submit-button';

export type SaveTradingLayoutFormState = {
  name: string;
  notes?: string;
};

export type SaveTradingLayoutFormProps = {
  onSubmit: (state: SaveTradingLayoutFormState) => void;
  initialValues?: Partial<SaveTradingLayoutFormState>;
  submitLabel?: string;
};

export const SaveTradingLayoutForm: FC<SaveTradingLayoutFormProps> = ({
  onSubmit,
  initialValues,
  submitLabel
}) => {
  const initialName = initialValues?.name ?? '';
  const initialNotes = initialValues?.notes ?? '';

  const formApi = useForm<SaveTradingLayoutFormState>({
    defaultValues: {
      name: initialName,
      notes: initialNotes
    }
  });
  const { handleSubmit, reset } = formApi;

  useEffect(() => {
    // This modal is reopened under the same window type, so RHF keeps the previous form state
    // unless we reset it when a different layout/shared resource is being edited.
    reset({
      name: initialName,
      notes: initialNotes
    });
  }, [initialName, initialNotes, reset]);

  return (
    <FormProvider {...formApi}>
      <Box
        component="form"
        sx={{ minHeight: 240 }}
        onSubmit={handleSubmit(onSubmit)}
      >
        <FormContainer layout="column">
          <FormField type="text" name="name" label="Name" />
          <FormField
            type="text"
            name="notes"
            label="Notes"
            multiline
            rows={5}
            placeholder="Optional notes"
          />
          <FieldWrapper>
            <SubmitButton text={submitLabel || 'Save'} />
          </FieldWrapper>
        </FormContainer>
      </Box>
    </FormProvider>
  );
};
